module.exports = __webpack_public_path__ + "img/bug_search.9a8b09b3.png";